import { ToolTye } from '../utils';

// 颜色预设
export enum ColorPresets {
  RED = '#FF525D',
  ORANGE = '#FF842C',
  YELLOW = '#FFD44C',
  GREEN = '#24C446',
  BLUE = '#2D8EFF',
  MAGENTA = '#FE50A1',
  PURPLE = '#AD5CF0',
  WHITE = '#FFFFFF',
}

// 画笔粗细预设
export enum WidthPresets {
  FINE = 1,
  MEDIUM = 2,
  THICK = 4,
  EXTRA_THICK = 6,
}

// 画笔字体大小预设
export enum FontSizePresets {
  FONT16 = 16,
  FONT20 = 20,
  FONT28 = 28,
  FONT40 = 40,
}

export type ToolValue = {
  type: ToolTye;
  strokeWidth?: number;
  color?: string;
};

export enum PEN_WIDTH {
  WIDTH_ULTRA_FINE = 'Ultra_Fine',
  WIDTH_STANDARD = 'Standard',
  WIDTH_BOLD = 'Bold',
  WIDTH_ULTRA_BOLD = 'Ultra_Bold',
}
